import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../../contexts";
// import SendForVital from "../modals/SendForVital";
// import SendForVital from "../modals/SendForVital";
import Cookies from "js-cookie";
import { RiEdit2Fill, RiEditBoxFill, RiEditCircleFill, RiFileEditLine, RiPencilFill, RiPencilLine, RiPulseLine } from "react-icons/ri";
import { AiOutlineEdit, AiOutlinePlus } from "react-icons/ai";
import WalkInModal from "../modals/WalkInModal";
import PayWalkInModal from "../modals/PayWalkInModal";
import PayWalkInLabRequest from "../modals/PayWalkInLabRequest";
import QueueWalkInModal from "../modals/QueueWalkIn";
import Spinner from "../UI/Spinner";
import TableSkeleton from "./TableSkeleton";
import { Delete } from "@mui/icons-material";
import { del } from "../../utility/fetch";
import notification from "../../utility/notification";

function QueuedWalkInTable({ data, currentPage, isQueue, itemsPerPage, loading, getProcedures , renderTabContent, isApproval }) {
    const { setPatientId, setPatientName, setPatientPage, setHmoId, setPatientInfo, nurseRoles, setHmoDetails } = usePatient();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [patientData, setData] = useState([]);

    let navigate = useNavigate();

    const closeModal = () => {
        setIsModalOpen(false);

    };

    const handleEdit = () => {

    }

    const selectRecord = (id, data) => {
        setIsModalOpen(true);
        setPatientName(`${data.firstName} ${data.lastName}`);
        setPatientInfo(data);
        setPatientId(id);
        Cookies.set('patientId', id);
        Cookies.set('patientInfo', JSON.stringify(data));
        Cookies.set('patientName', `${data.firstName} ${data.lastName}`);
    };


    const addToQueue = (data) => {
        setData(data);
        setIsModalOpen(true);

    }

    const handleDelete = async (id) => {
        try {
              let res = await del(`/walkinlabrequest/${id}/delete-walk-in-lab-request`)
     if(res){
        notification({ message: 'Walk-in lab request deleted successfully', type: 'success' });
        getProcedures();
     }
     else{
        notification({ message: 'Failed to delete walk-in lab request', type: 'error' });
     }
        } catch (error) {
            notification({ message: 'An error occurred while deleting the walk-in lab request', type: 'error' });
        }
   
    }


    const continueUpdate = (data) => {
        setPatientInfo(data);
    };

    // helper to render approval status cell
    const renderApprovalStatus = (row) => {
        console.log('renderApprovalStatus row:', row);
        // find a representative test request to read isApproved
        // if row itself is a walkIn request object that contains walkInTestRequests array, check first item; otherwise use row.isApproved
        let value = row?.isApproved;
        if (value === undefined && Array.isArray(row?.walkInTestRequests) && row.walkInTestRequests.length > 0) {
            // If there are multiple requests we choose display logic: if any approved => Approved, if any declined => Declined, else New
            const approvals = row.walkInTestRequests.map(r => r.isApproved);
            if (approvals.includes(true)) value = true;
            else if (approvals.includes(false)) value = false;
            else value = null;
        }

        const styleBase = { padding: '6px 10px', borderRadius: 6, display: 'inline-block', fontWeight: 700, fontSize: 12 };
        if (value === null || value === undefined) {
            return <td><span style={{ ...styleBase, color: '#555', background: '#f4f4f4' }}>NEW</span></td>;
        }
        if (value === true) {
            return <td><span style={{ ...styleBase, color: '#155724', background: '#d4edda' }}>APPROVED</span></td>;
        }
        // value === false
        return <td><span style={{ ...styleBase, color: '#721c24', background: '#f8d7da' }}>DECLINED</span></td>;
    };

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
        return (
            <div className="w-100">
                <h2 className="m-t-20 m-b-20">QUEUED FOR LAB</h2>
                <div className="flex flex-col gap-12">
                    {loading ? (
                        <TableSkeleton />
                    ) : (
                        Array.isArray(data) && data?.map((row) => {
                            // Logic for approval status text/color for mobile
                            let approvalStatus = 'NEW';
                            let approvalColor = '#555';
                            let approvalBg = '#f4f4f4';
                            let value = row?.isApproved;
                            if (value === undefined && Array.isArray(row?.walkInTestRequests) && row.walkInTestRequests.length > 0) {
                                const approvals = row.walkInTestRequests.map(r => r.isApproved);
                                if (approvals.includes(true)) value = true;
                                else if (approvals.includes(false)) value = false;
                                else value = null;
                            }
                            if (value === true) { approvalStatus = 'APPROVED'; approvalColor = '#155724'; approvalBg = '#d4edda'; }
                            else if (value === false) { approvalStatus = 'DECLINED'; approvalColor = '#721c24'; approvalBg = '#f8d7da'; }

                            return (
                                <div key={row?.patientId || row?.id} className="card shadow-sm m-b-20" style={{ borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }} onClick={() => continueUpdate(row)}>
                                    <div className="flex flex-h-between flex-v-center" style={{ padding: '15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                                        <h4 className="m-0" style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{row?.walkInPatient?.firstName} {row?.walkInPatient?.lastName} {row?.isReferred ? <span className="add-note" style={{fontSize: '10px'}}>(Referred)</span> : ''}</h4>
                                        <span style={{ fontSize: '12px', color: '#666' }}>{row?.walkInPatient?.walkInPatientRef}</span>
                                    </div>
                                    <div style={{ padding: '15px' }}>
                                        <div className="m-b-5" style={{ fontSize: '14px' }}><strong>Email:</strong> {row?.walkInPatient?.email}</div>
                                        <div className="m-b-5" style={{ fontSize: '14px' }}><strong>Mobile:</strong> {row?.walkInPatient?.phoneNumber}</div>
                                        <div className="m-b-10" style={{ fontSize: '14px' }}><strong>Gender:</strong> {row?.walkInPatient?.gender}</div>
                                        <div className="flex flex-h-between flex-v-center">
                                            <span style={{ fontSize: '12px', color: '#888' }}>{new Date(row?.createdAt).toLocaleDateString()}</span>
                                            <span style={{ padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', color: approvalColor, backgroundColor: approvalBg }}>{approvalStatus}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-h-end flex-v-center" style={{ padding: '10px 15px', backgroundColor: '#f8f9fa', borderTop: '1px solid #eee', gap: '15px' }}>
                                        <AiOutlinePlus size={22} onClick={(e) => { e.stopPropagation(); addToQueue(row); }} className="pointer" />
                                        {!isQueue && <Delete style={{ color: 'red', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleDelete(row?.id) }} />}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
                {isModalOpen && <PayWalkInLabRequest isApproval={isApproval} isQueue={isQueue} closeModal={closeModal} patientData={patientData} getProcedures={getProcedures} />}
            </div>
        );
    }

    return (
        <div className="w-100">

            <div className="w-100 none-flex-item m-t-40">
                <h2>QUEUED FOR LAB</h2>
                <table className="bordered-table m-t-20">
                    <thead className="border-top-none">
                        <tr className="border-top-none">
                            <th className="center-text">Lab Id</th>
                            {/* <th className="center-text">Patient Id</th> */}
                            <th className="center-text">First Name</th>
                            <th className="center-text">Last Name</th>
                            <th className="center-text">Email</th>
                            {/* <th className="center-text">Username</th> */}
                            <th className="center-text">Mobile Number</th>
                            <th className="center-text">Gender</th>
                            <th className="center-text">Created On</th>
                    {<th className="center-text">Approval Status</th> }
                            <th className="center-text">Action</th>
                            <>
                                {nurseRoles?.includes('checkin') &&
                                    <th className="center-text"></th>
                                }
                            </>
                        </tr>
                    </thead>

                    {loading ? (
                        <TableSkeleton primary={5} secondary={9} />
                    ) : <tbody className="white-bg view-det-pane">
                        {Array.isArray(data) &&
                            data?.map((row, index) => (
                                <tr className="hovers " onClick={() => continueUpdate(row)} key={row?.patientId || row?.id}>
                                    <td>{row?.walkInPatient?.walkInPatientRef}</td>
                                    {/* <td>{row?.patientRef}</td> */}
                                    <td>
                                        <div>
                                            {row?.walkInPatient?.firstName} {row?.isReferred ? <span className="add-note">Referred</span> : ''}
                                        </div>
                                    </td>
                                    <td>{row?.walkInPatient?.lastName}</td>
                                    <td>{row?.walkInPatient?.email}</td>
                                    <td>{row?.walkInPatient?.phoneNumber}</td>
                                    <td>{row?.walkInPatient?.gender}</td>
                                    <td>{new Date(row?.createdAt).toLocaleDateString()}</td>
                                   {renderApprovalStatus(row) }
                                    <td className="flex flex-h-center flex-v-center">
                                        <AiOutlinePlus size={25} onClick={() => addToQueue(row)} className="m-r-20 pointer" />
                                            {!isQueue && <Delete style={{ color: 'red', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleDelete(row?.id)}} />}
                                        </td>
                                    {/* <>
                    {nurseRoles?.includes('checkin') &&
                      <td><button onClick={(e) => { e.stopPropagation(); selectRecord(row?.patientId || row?.id, row) }} className="submit-btn">Send for vitals</button></td>
                    }
                  </> */}
                                </tr>
                            ))}
                    </tbody>}
                </table>
            </div>

            {isModalOpen &&
                <PayWalkInLabRequest
                    isApproval={isApproval}
                    isQueue={isQueue}
                    closeModal={closeModal}
                    patientData={patientData}
                    getProcedures={getProcedures}
                />
            }
        </div>
    );
}

export default QueuedWalkInTable;